<template>
  <div class="container">
    <img
      src="@/assets/images/backgrounds/triangle_background.png"
      class="triangle-background-image"
      alt="Achtergrond"
    />

    <div class="header-container">
      <div v-if="!emptyResults && testName !== ''">
        <h1>{{ userInformation.firstName }}
          {{$styleConfiguration.test_results_info[this.testName].header_title}}</h1>
      </div>

      <div v-if="emptyResults">
        <h1>{{ userInformation.firstName }}</h1>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'WaardenResultsHeader',
  data() {
    return {
      emptyResults: false,
      testName: '',
    };
  },
  computed: {
    ...mapGetters({
      userInformation: 'user/userInformation',
      waardenResults: 'waardenResults/waardenResults',
    }),
  },
  watch: {
    waardenResults(newValue) {
      this.emptyResults = newValue.emptyResults;
    },
  },
  mounted() {
    this.testName = this.$route.params.testIdentifier;
  },
};
</script>

<style lang="sass" scoped>
.container
  @include flex-column(center)
  align-items: center
  padding: 0 $standard-margin-size
  height: 300px

  & .header-container
    @include flex-column(center)
    & .result-bubbles-container
      @include flex-row(center)

  & .triangle-background-image
    position: absolute
    height: 300px
    width: calc(90vw - 2 * #{$standard-margin-size})
    z-index: -10
</style>
